import { Outlet } from "react-router-dom";
import { ProtectedRouteABM } from "./ProtectedRouteABM";

export const NivelRoutes = ({ nivel = 9 }) => (
  <ProtectedRouteABM nivel={nivel}>
    <Outlet />
  </ProtectedRouteABM>
); 